module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAYUlEQVQoU2NkwAK8pjxRY/j1n31bkexldGlGbBo8JjyzYWL4s4aJidFvS57sKWQ1WDWAFHhNfObB8P/PAnRNODXg0oRXAzZNBDUga2L4x+hKfQ3onqeep0kKVpIjDl/SAAB0Nk3dESsgPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/branch-arrow-blue.png
// module id = i0iU
// module chunks = 1